export default __webpack_public_path__ + "static/media/guesty_step10.9533e71c.png";